<template>
  <div class="auth-bootstrap">
    <div class="auth-bootstrap-card">
      <h4>Preparing Ops Fleet Session</h4>
      <p>Loading your permissions...</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { completeKeycloakLogin } from '../../../services/keycloak'
import { getSafeReturnTo } from '../../../helpers/auth/ssoRedirect'

export default {
  name: 'AuthBootstrap',
  async mounted () {
    try {
      const session = await completeKeycloakLogin(this.$route.query)
      const res = await this.bootstrapSsoSession(session)

      if (res.status === 'success') {
        this.$router.replace(getSafeReturnTo(session.returnTo, '/dashboard/home'))
        return
      }
    } catch (e) {
      // fall through to login error
    }

    this.$router.replace({ path: '/auth1', query: { error: 'sso_failed' } })
  },
  methods: {
    ...mapActions('Auth', ['bootstrapSsoSession'])
  }
}
</script>

<style scoped>
.auth-bootstrap {
  align-items: center;
  background: #f6f7fb;
  display: flex;
  justify-content: center;
  min-height: 100vh;
}

.auth-bootstrap-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12);
  padding: 32px;
  text-align: center;
}
</style>
